<template>
  <div class="stage-item position-relative">
    <gf-custom-tooltip root="custom-table">
      <template #element>
        <div
          tabindex="0"
          ref="job"
          class="d-flex align-items-center stage-item position-relative"
          :style="'color: #' + stage.status.hexColor"
          @click="showStageJobs"
        >
        <gf-dropdown-ci-cd
            position="right"
            :btn-class="`btn btn-sm bg-transparent stage-item__icon-btn ${btnClass}`"
            :btn-icon="iconClass"
            :no-carret="true"
            :list-length="pipelineStageJobsListLength"
            style="border: none; --gfd-minw: 150px; display: none; float: right; cursor: default;"
        >
        <template>
          <div v-if="isVisibleStageJobs">
            <ci-pipelines-job-item-dropdown
              v-for="job in pipelineStageJobsList"
              :key="job.id"
              :job="job"
              :icons-size="1"
              :is-light="true"
              class="my-1" 
              @openModal="onRepeatJob"  
            />
          </div>
          <div v-else class="dropdown__stages-loader">
            <packman-loader :style="{ top: '30%' }" :size="20" />
          </div>
        </template>

      </gf-dropdown-ci-cd>

          <gf-custom-modal-window
            ref="gfCustomModalWindowRestartJob"
            class="text-dark"
            :gf-modal-data-name="'restartJobModal-' + jobId"
            :gf-modal-header="$t('ci_cd.job.jobRestartConfirmation')"
            :gf-modal-wrapper-width="'500px'"
            :gf-modal-wrapper-height="'auto'"
            :headerLevel="6"
            :gfModalBodyAdditionalClasses="'p-1'"
          >
            <template #body>
              <div class="d-flex justify-content-end">
                <button
                  type="button"
                  class="btn btn-secondary btn-sm m-1"
                  @click="closeRestartJobModal"
                >
                  {{ $t('ci_cd.job.jobCancel') }}
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-sm m-1"
                  @click="restartJob"
                >
                  {{ $t('ci_cd.job.jobConfirm') }}
                </button>
              </div>
            </template>
          </gf-custom-modal-window>
        </div>
      </template>
      <template #content>
        {{ stage.name }}
      </template>
    </gf-custom-tooltip>
  </div>
</template>

<script>
import GfCustomTooltip from '@shared/shared-components/shared/GfCustomTooltip';
import DotsLoader from '@shared/shared-components/shared/dots-loader';
import CiPipelinesJobItemDropdown from '@shared/modules/ci-cd/components/ci-pipelines-job-item-dropdown';
import { PIPELINE_STATUS_ENUM } from '@shared/modules/ci-cd/ci-cd.constants';
import CiCdService from '../ci-cd.service';
import CiCdMessages from '@shared/modules/ci-cd/ci-cd.messages';
import packmanLoader from '@/shared-modules/shared-components/shared/packman-loader';

export default {
  name: 'PipelineStageItem',
  components: {
    CiPipelinesJobItemDropdown,
    DotsLoader,
    GfCustomTooltip,
    packmanLoader
  },
  props: {
    stage: {
      default: null,
      type: Object
    },
    pipelineId: {
      default: null
    }
  },
  data() {
    return {
      PIPELINE_STATUS_ENUM,
      fontScale: '1.5',
      isVisibleStageJobs: false,
      isModalWindowOpened: false,
      jobId: null
    };
  },
  computed: {
    pipelineStageJobsList() {
      return this.$store.getters.getPipelineStageJobsList;
    },
    pipelineStageJobsListLength() {
      return this.pipelineStageJobsList.length
    },
    iconClass() {
      switch (this.stage.status.id) {
        case PIPELINE_STATUS_ENUM.CREATED:
          return 'gf-icon gf-icon-plus-circle text-secondary';
        case PIPELINE_STATUS_ENUM.PENDING:
          return 'gf-icon gf-icon-pause-circle text-secondary';
        case PIPELINE_STATUS_ENUM.RUNNING:
          return 'gf-icon gf-icon-play-circle text-info';
        case PIPELINE_STATUS_ENUM.SUCCESS:
          return 'gf-icon gf-icon-check-circle text-success';
        case PIPELINE_STATUS_ENUM.FAILED:
          return 'gf-icon gf-icon-alert text-danger';
        case PIPELINE_STATUS_ENUM.CANCELED:
          return 'gf-icon gf-icon-stop-circle text-warning';
        case PIPELINE_STATUS_ENUM.SKIPPED:
          return 'gf-icon gf-icon-skip-circle text-warning';
        case PIPELINE_STATUS_ENUM.MANUAL:
        case PIPELINE_STATUS_ENUM.SCHEDULED:
          return 'gf-icon gf-icon-person-circle text-warning';
        case PIPELINE_STATUS_ENUM.PREPARING:
        case PIPELINE_STATUS_ENUM.WAITING_FOR_RESOURCE:
          return 'gf-icon gf-icon-pause-circle text-warning';
        case PIPELINE_STATUS_ENUM.WARNING:
          return 'gf-icon gf-icon-info text-warning'
        default:
          return 'gf-icon gf-icon-info text-secondary';
      }
    },
    btnClass() {
      switch (this.stage.status.id) {
        case PIPELINE_STATUS_ENUM.CREATED:
          return 'btn-secondary btn-outline-secondary';
        case PIPELINE_STATUS_ENUM.PENDING:
          return 'btn-secondary btn-outline-secondary';
        case PIPELINE_STATUS_ENUM.RUNNING:
          return 'btn-info btn-outline-info';
        case PIPELINE_STATUS_ENUM.SUCCESS:
          return 'btn-success btn-outline-success';
        case PIPELINE_STATUS_ENUM.FAILED:
          return 'btn-danger btn-outline-danger';
        case PIPELINE_STATUS_ENUM.CANCELED:
          return 'btn-secondary btn-outline-warning';
        case PIPELINE_STATUS_ENUM.SKIPPED:
          return 'btn-warning btn-outline-warning';
        case PIPELINE_STATUS_ENUM.MANUAL:
        case PIPELINE_STATUS_ENUM.SCHEDULED:
          return 'btn-warning btn-outline-warning';
        case PIPELINE_STATUS_ENUM.PREPARING:
        case PIPELINE_STATUS_ENUM.WAITING_FOR_RESOURCE:
          return 'btn-warning btn-outline-warning';
          case PIPELINE_STATUS_ENUM.WARNING:
          return 'btn-warning btn-outline-warning'
        default:
          return 'btn-light btn-outline-light';
      }
    }
  },
  mounted() {
    document.addEventListener('click', (e) => {
      this.closeDropdownJob(e);
    });
  },
  methods: {
    showStageJobs() {
      this.isVisibleStageJobs = false;
      CiCdService.getPipelineStageJob(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.pipelineId,
        this.stage.id
      ).then(() => {
        this.isVisibleStageJobs = true;
      })
    },
    closeRestartJobModal() {
      this.$refs.gfCustomModalWindowRestartJob.closeModalWindow();
    },

    onRepeatJob(job) {
      this.jobId = job;
      this.$refs.gfCustomModalWindowRestartJob.openModalWindow();
    },
    closeDropdownJob(event) {
      if (!event) return;
      if (event.target !== this.$refs.job && !event.target.closest('.dropdown-jobs-container')) {
      }
    },
    restartJob() {
      CiCdService.startJob(
        this.alias || this.$route.params.alias,
        this.projectAlias || this.$route.params.projectAlias,
        this.jobId
      )
        .then(() => {
          window.location.reload();
        })
        .catch((err) => {
          console.error(err);
        });
    }
  },
  i18n: {
    messages: CiCdMessages
  }
};
</script>

<style lang="scss">
// передаю этот класс в dropdown btn
.stage-item__icon-btn {
  border: none;
  padding: 0;
  cursor: pointer;
  // line-height: 0;
  min-height: initial !important;
  border-radius: 100%;

    & > i {
      font-size: 28px;
    }
}

.dropdown__stages-loader {
  position: relative;
  min-height: 25px;
}

.stage-item {
  display: inline-block;
  position: relative;
  cursor: pointer;

  &:not(:last-child) {
    &:before {
      display: block;
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 85%;
      height: 2px;
      background-color: #ccc;
      width: 7px;
    }
  }

  & svg {
    pointer-events: none;
  }
}
</style>
